import * as React from 'react';
const Percent = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-percent", ...props },
    React.createElement("line", { x1: "19", y1: "5", x2: "5", y2: "19" }),
    React.createElement("circle", { cx: "6.5", cy: "6.5", r: "2.5" }),
    React.createElement("circle", { cx: "17.5", cy: "17.5", r: "2.5" })));
export default Percent;
//# sourceMappingURL=Percent.js.map